import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Sparkles, Lock, Mail } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/auth/login", { email: email.trim(), password });
      setUser(res.data);
      navigate(res.data.role === "admin" ? "/dashboard" : "/pos");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2">
      <div className="hidden md:block relative" style={{
        backgroundImage: "url(https://images.pexels.com/photos/5908235/pexels-photo-5908235.jpeg)",
        backgroundSize: "cover", backgroundPosition: "center"
      }}>
        <div className="absolute inset-0 bg-gradient-to-br from-terracotta/40 to-ochre/30 mix-blend-multiply" />
        <div className="absolute bottom-12 left-12 text-white max-w-sm">
          <div className="label-overline text-white/80 mb-3">MDM Bill Software</div>
          <h1 className="font-heading text-5xl font-bold leading-tight">
            Bill banao,<br />stock sambhalo,<br />grow karo.
          </h1>
          <p className="mt-4 text-sm text-white/90">Multi-shop billing • AI insights • Loyalty points • Beautiful receipts.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 bg-sand">
        <form onSubmit={submit} className="w-full max-w-md">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 rounded bg-terracotta flex items-center justify-center text-white font-heading font-bold text-xl">M</div>
            <div>
              <div className="font-heading text-2xl font-bold text-ink">MDM Bill Software</div>
              <div className="label-overline text-muted-foreground">Multi-shop POS</div>
            </div>
          </div>
          <h2 className="font-heading text-3xl font-bold text-ink">Welcome back</h2>
          <p className="text-muted-foreground mt-1">Login with your registered email and password</p>

          <div className="space-y-4 mt-6">
            <div>
              <Label className="text-xs uppercase tracking-widest text-muted-foreground">Email</Label>
              <div className="relative mt-1">
                <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"/>
                <Input data-testid="login-email" type="email" autoFocus required className="pl-9 h-11" placeholder="you@example.com" value={email} onChange={(e)=>setEmail(e.target.value)} />
              </div>
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-muted-foreground">Password</Label>
              <div className="relative mt-1">
                <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"/>
                <Input data-testid="login-password" type="password" required className="pl-9 h-11" placeholder="••••••••" value={password} onChange={(e)=>setPassword(e.target.value)} />
              </div>
            </div>
            <Button type="submit" disabled={busy} data-testid="login-btn" className="w-full bg-terracotta hover:bg-terracotta-hover text-white h-11">
              {busy ? "Signing in…" : "Login"}
            </Button>
          </div>

          <div className="mt-8 flex items-center gap-2 text-xs text-muted-foreground">
            <Sparkles size={14} className="text-ochre" />
            Don't have an account? Ask your admin to create one.
          </div>
        </form>
      </div>
    </div>
  );
}
